import type { DashboardGranularity } from "./dashboard-form";

interface DashboardListenerFormLike {
    getRoot(): HTMLElement;
    getGranularityButtonFromEvent(event: Event): HTMLButtonElement | null;
    getChartLegendButtonFromEvent(event: Event): HTMLButtonElement | null;
    getTabButtonFromEvent(event: Event): HTMLButtonElement | null;
    activateTab(key: string): void;
}

interface DashboardListenerHandlerLike {
    handleGranularityChange(value: DashboardGranularity, button: HTMLButtonElement): void;
}

interface DashboardListenerRenderLike {
    toggleLegendDataset(button: HTMLButtonElement): void;
}

export class DashboardListener {
    private readonly form: DashboardListenerFormLike;

    private readonly handler: DashboardListenerHandlerLike;

    private readonly render: DashboardListenerRenderLike;

    public constructor(
        form: DashboardListenerFormLike,
        handler: DashboardListenerHandlerLike,
        render: DashboardListenerRenderLike,
    ) {
        this.form = form;
        this.handler = handler;
        this.render = render;
    }

    public register(): void {
        const root = this.form.getRoot();
        if (root.dataset.adminDashboardBound === "1") {
            return;
        }
        root.dataset.adminDashboardBound = "1";

        root.addEventListener("click", (event) => {
            const legendButton = this.form.getChartLegendButtonFromEvent(event);
            if (legendButton) {
                this.render.toggleLegendDataset(legendButton);
                return;
            }

            const tabButton = this.form.getTabButtonFromEvent(event);
            if (tabButton && tabButton.dataset.dashboardTab) {
                this.form.activateTab(tabButton.dataset.dashboardTab);
                return;
            }

            const button = this.form.getGranularityButtonFromEvent(event);
            if (!button) {
                return;
            }
            const value: DashboardGranularity = button.dataset.granularity === "monthly" ? "monthly" : "daily";
            this.handler.handleGranularityChange(value, button);
        });
    }
}
